import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {AlertService} from '../../shared/services/alert.service';
import {Messages} from '../../shared/constants/messages';
import {PermissionService} from '../services/permission.service';

export const authGuard: CanActivateFn = (route, state) => {

  const router: Router = inject(Router);
  const alertService: AlertService = inject(AlertService)
  const permissionService: PermissionService = inject(PermissionService);

  if (permissionService.isLogged()) {
    return true;
  }
  alertService.showError(Messages.LOGIN_REQUIRED)
  return router.navigate(['/login']);
};






